module.exports = __webpack_public_path__ + "media/images/sosial_media/yt-full-c-6b41a73d790cac9512e901a833411b1a.png";